/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeries/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function ImageSeries({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/ImageSeries"
  
}) {
let imagesRequestPatientImageSeriesNameValueData = fromData.useDataValue({ viewPath,
context: 'images_request',
path: 'patient_image_series.name',
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 overflowX="visible"
 overflowY="visible"
 data="images_request.patient_image_series.name"
 text={imagesRequestPatientImageSeriesNameValueData}
/>
{children}
</React.Fragment>)
}